// // ManageOrders.jsx (GenericTable version)
// // - Uses GenericTable like your User component
// // - Keeps View & Delivery buttons unchanged
// // - Expands OrderCard under clicked row (Option A)
// // - Pagination default = 5 rows per page

// import React, { useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import GenericTable from "../Components/DynamicComp/Table"; // same pattern as your User component
// import OrderCard from "./OrderCard";
// import { GetOrderData } from "./OrderFunction";
// import { showAlert } from "../Components/DynamicComp/Alert"; // adjust path if needed

// const ManageOrders = () => {
//   // raw grouped form (keeps original fetching logic)
//   const [groupedOrders, setGroupedOrders] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [refetchToggle, setRefetchToggle] = useState(false);

//   // filters & controls
//   const [searchTerm, setSearchTerm] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [dateFilter, setDateFilter] = useState("");
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [viewOrderItems, setViewOrderItems] = useState([]);
//   const [viewOrderId, setViewOrderId] = useState(null);

//   const [providers, setProviders] = useState([]);

//   // courier modal + state
//   const [showCourierModal, setShowCourierModal] = useState(false);
//   const [courierData, setCourierData] = useState({
//     provider: "",
//     tracking: "",
//     link: "",
//     notes: "",
//   });
//   const [selectedOrderId, setSelectedOrderId] = useState(null);
//   const [courierError, setCourierError] = useState("");

//   // pagination (GenericTable will handle pagination UI; we pass default rowsPerPage)
//   const rowsPerPageOptions = [5, 10, 20];
//   const defaultRowsPerPage = 5;

//   // expanded row (orderId) to show OrderCard below that row
//   const [expandedRow, setExpandedRow] = useState(null);

//   // fetch orders (grouping preserved to avoid changing backend assumptions)
//   useEffect(() => {
//     fetchOrders();
//     // reset expanded row on refetch
//     setExpandedRow(null);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [refetchToggle]);

//   const fetchOrders = async () => {
//     setLoading(true);
//     try {
//       const res = await GetOrderData();
//       const arr = Array.isArray(res?.data) ? res.data : [];
//       // group by order_id
//       const grouped = arr.reduce((acc, it) => {
//         const id = it.order_id;
//         if (!acc[id]) acc[id] = [];
//         acc[id].push(it);
//         return acc;
//       }, {});
//       // sort each group's items by created_at desc
//       Object.keys(grouped).forEach((k) => {
//         grouped[k].sort(
//           (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0)
//         );
//       });
//       setGroupedOrders(grouped);
//     } catch (err) {
//       console.error("Fetch orders error:", err);
//       showAlert?.("Failed to fetch orders", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleRefetch = () => setRefetchToggle((p) => !p);
//   // Load courier providers only once
//   useEffect(() => {
//     const fetchProviders = async () => {
//       try {
//         const res = await axios.get(
//           "http://localhost:5000/api/orders/delivery-providers"
//         );
//         setProviders(res.data || []);
//       } catch (err) {
//         console.error("Failed to load providers", err);
//       }
//     };

//     fetchProviders();
//   }, []);

//   // const checkBarcodeStock = async () => {
//   //   if (!barcode.trim()) {
//   //     setBatchResult("Enter a valid barcode");
//   //     return;
//   //   }

//   //   const batchCode = barcode.trim().split(" ").pop();
//   //   const encoded = encodeURIComponent(batchCode);

//   //   setLoadingBatch(true);

//   //   try {
//   //     const res = await axios.get(
//   //       `http://localhost:5000/api/batch/code/${encoded}`
//   //     );

//   //     if (!res.data.success) {
//   //       setBatchResult("Batch not found");
//   //     } else {
//   //       const qty = res.data.quantity;
//   //       setBatchResult(qty > 0 ? `In Stock (Qty: ${qty})` : "Out of Stock");
//   //     }
//   //   } catch (err) {
//   //     console.error(err);
//   //     setBatchResult("Server error");
//   //   }

//   //   setLoadingBatch(false);
//   // };

//   // Flatten groupedOrders into rows suitable for GenericTable
//   // Each row: { orderId, name, date, amount, status, items }
//   const allRows = useMemo(() => {
//     const entries = Object.entries(groupedOrders || {});
//     return entries.map(([orderId, items]) => {
//       const first = items[0] || {};
//       const totalAmount = items.reduce(
//         (t, it) => t + Number(it.amount || 0) * Number(it.quantity || 1),
//         0
//       );
//       return {
//         orderId,
//         name: first.name || "-",
//         date: first.created_at || first.updated_at || "",
//         amount: Number(totalAmount || 0).toFixed(2),
//         status: first.status || "-",
//         items,
//       };
//     });
//   }, [groupedOrders]);

//   // Apply filters & search on flattened rows
//   const filteredRows = useMemo(() => {
//     const lower = searchTerm.trim().toLowerCase();
//     return (
//       allRows
//         .filter((r) => {
//           // search across orderId, name, phone/mobile inside items
//           if (lower) {
//             const matches =
//               (r.orderId || "").toLowerCase().includes(lower) ||
//               (r.name || "").toLowerCase().includes(lower) ||
//               r.items.some((it) =>
//                 ((it.phone || it.mobile || "") + "")
//                   .toLowerCase()
//                   .includes(lower)
//               );
//             if (!matches) return false;
//           }

//           // status filter
//           if (
//             statusFilter &&
//             statusFilter !== "all" &&
//             (r.status || "").toLowerCase() !== statusFilter.toLowerCase()
//           ) {
//             return false;
//           }

//           // date filter (yyyy-mm-dd)
//           if (dateFilter) {
//             const matchesDate = r.items.some(
//               (it) =>
//                 new Date(it.created_at).toISOString().slice(0, 10) ===
//                 dateFilter
//             );
//             if (!matchesDate) return false;
//           }

//           return true;
//         })
//         // Sort newest first (by date)
//         .sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0))
//     );
//   }, [allRows, searchTerm, statusFilter, dateFilter]);

//   // Quick stats (optional)
//   const stats = useMemo(() => {
//     const flat = allRows.flatMap((r) => r.items);
//     const countBy = (s) =>
//       flat.filter(
//         (it) => (it.status || "").toString().toLowerCase() === s.toLowerCase()
//       ).length;
//     return {
//       newOrders: flat.filter(
//         (it) => (it.status || "").toString().toLowerCase() === "pending"
//       ).length,
//       inTransit:
//         countBy("shipped") + countBy("in transit") + countBy("intransit"),
//       delivered: countBy("delivered"),
//       total: flat.length,
//     };
//   }, [allRows]);

//   // Table columns (matches the layout you accepted)
//   const columns = [
//     { key: "orderId", label: "Order ID", sortable: false },
//     { key: "name", label: "Customer", sortable: false },
//     { key: "date", label: "Order Date", sortable: false },
//     { key: "amount", label: "Amount", sortable: false },
//     { key: "status", label: "Status", sortable: false },
//     {
//       key: "actions",
//       label: "Actions",
//       align: "center",
//       width: "160px",
//       sortable: false,
//     },
//   ];

//   const handleCancelOrder = async (row) => {
//     if (!window.confirm(`Cancel order #${row.orderId}?`)) return;

//     try {
//       const res = await axios.post(
//         "http://localhost:5000/api/orders/update-status",
//         {
//           order_id: row.orderId,
//           status: "cancelled",
//         }
//       );

//       if (res?.data?.success) {
//         showAlert?.("Order cancelled successfully!", "success");

//         setGroupedOrders((prev) => {
//           const copy = { ...prev };
//           if (copy[row.orderId]) {
//             copy[row.orderId] = copy[row.orderId].map((it) => ({
//               ...it,
//               status: "cancelled",
//             }));
//           }
//           return copy;
//         });
//       }
//     } catch (err) {
//       showAlert?.("Failed to cancel order", "error");
//     }
//   };

//   // Keep View button EXACTLY as your original code requested
//   const handleToggleExpand = (orderId) =>
//     setExpandedRow((prev) => (prev === orderId ? null : orderId));

//   const handleOpenCourierModal = async (orderId) => {
//     setSelectedOrderId(orderId);
//     setCourierError("");

//     try {
//       // fetch existing delivery data
//       const res = await axios.get(
//         `http://localhost:5000/api/order-delivery/${orderId}`
//       );

//       const d = res.data || {};

//       setCourierData({
//         provider: d.delivery_provider || "",
//         tracking: d.tracking_id || "",
//         link: d.tracking_link || "",
//         notes: d.notes || "",
//       });
//     } catch (err) {
//       console.error("Failed to load delivery details", err);

//       setCourierData({
//         provider: "",
//         tracking: "",
//         link: "",
//         notes: "",
//       });
//     }

//     setShowCourierModal(true);
//   };

//   const handleCourierSave = async () => {
//     setCourierError("");

//     if (!courierData.provider.trim() || !courierData.tracking.trim()) {
//       setCourierError("Delivery Provider & Tracking Number are required!");
//       return;
//     }

//     try {
//       const payload = {
//         order_id: selectedOrderId,
//         delivery_provider: courierData.provider,
//         tracking_id: courierData.tracking,
//         tracking_link: courierData.link,
//         notes: courierData.notes,
//       };

//       const res = await axios.post(
//         "http://localhost:5000/api/orders/order-delivery/save",
//         payload
//       );

//       if (res?.data?.success) {
//         showAlert({
//           type: "success",
//           title: "Delivery Details Submitted Successfully",
//           // message: "Your campaign will be reviewed.",
//           duration: 2500,
//         });
//         setShowCourierModal(false);
//       } else {
//         showAlert("Failed to save delivery details!", "error");
//       }
//     } catch (err) {
//       console.error(err);
//       showAlert("Server error!", "error");
//     }
//   };

//   // Custom renderers for the GenericTable columns
//   const customRenderers = {
//     date: (row) => {
//       try {
//         return new Date(row.date).toLocaleDateString();
//       } catch {
//         return "-";
//       }
//     },
//     amount: (row) => `₹${row.amount}`,
//     status: (row) => {
//       const s = (row.status || "").toLowerCase();

//       const map = {
//         delivered: "bg-green-100 text-green-700",
//         pending: "bg-yellow-100 text-yellow-700",
//         cancelled: "bg-red-100 text-red-700",
//         shipped: "bg-orange-100 text-orange-700",
//         "in transit": "bg-orange-100 text-orange-700",
//         intransit: "bg-orange-100 text-orange-700",
//       };

//       const cls = map[s] || "bg-gray-100 text-gray-700";

//       return (
//         <span className={`px-3 py-1 rounded-full text-xs font-semibold ${cls}`}>
//           {row.status}
//         </span>
//       );
//     },

//     actions: (row) => (
//       <div className="flex items-center justify-center gap-2">
//         {/* VIEW button: KEPT EXACTLY as-is */}
//         <button
//           onClick={() => {
//             setViewOrderId(row.orderId);
//             setViewOrderItems(row.items);
//             setShowViewModal(true);
//           }}
//           className="px-3 py-1 bg-indigo-600 text-white rounded-md text-xs"
//         >
//           View
//         </button>

//         {/* DELIVERY button: KEPT EXACTLY as-is */}
//         <button
//           onClick={() => handleOpenCourierModal(row.orderId)}
//           className="px-3 py-1 bg-green-600 text-white rounded-md text-xs"
//         >
//           Delivery
//         </button>
//         {/* DELETE ICON */}
//         <button
//           onClick={() => handleCancelOrder(row)}
//           className="px-2 py-1 bg-red-600 text-white rounded-md text-xs"
//           title="Cancel Order"
//         >
//           <i className="bi bi-trash"></i>
//         </button>
//       </div>
//     ),
//   };

//   // This is the function we will pass to GenericTable to render an expanded row below the clicked row.
//   // NOTE: If your GenericTable doesn't currently accept `renderExpandedRow`, I can provide the small patch for GenericTable.
//   const renderExpandedRow = (row) => {
//     if (expandedRow !== row.orderId) return null;
//     return (
//       <div className="w-full bg-gray-50 p-4 border-t">
//         {/* <OrderCard orderId={row.orderId} items={row.items} handleRefetch={handleRefetch} /> */}
//         <OrderCard
//           orderId={row.orderId}
//           items={row.items}
//           handleRefetch={handleRefetch}
//         />
//       </div>
//     );
//   };

//   // fallback if GenericTable doesn't support renderExpandedRow: keep a separate map to render below table (still visible)
//   // (But since you chose Option A, we are using renderExpandedRow prop for inline expansion.)
//   // If GenericTable doesn't have that prop, tell me and I'll give the tiny GenericTable change.

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen w-full">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="mb-6">
//           <h1 className="text-3xl font-bold text-gray-800">Order Dashboard</h1>
//         </div>

//         {/* Stats */}
//         <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
//           <div className="bg-white p-4 rounded-xl shadow-sm border">
//             <p className="text-sm text-gray-500">New Orders</p>
//             <p className="text-2xl font-semibold text-indigo-600">
//               {stats.newOrders}
//             </p>
//           </div>

//           <div className="bg-white p-4 rounded-xl shadow-sm border">
//             <p className="text-sm text-gray-500">In Transit</p>
//             <p className="text-2xl font-semibold text-orange-500">
//               {stats.inTransit}
//             </p>
//           </div>

//           <div className="bg-white p-4 rounded-xl shadow-sm border">
//             <p className="text-sm text-gray-500">Delivered</p>
//             <p className="text-2xl font-semibold text-emerald-600">
//               {stats.delivered}
//             </p>
//           </div>
//         </div>

//         {/* Controls */}
//         <div className="bg-white p-4 rounded-xl shadow-sm border mb-6">
//           <div className="flex flex-col md:flex-row md:items-center gap-3">
//             <div className="flex-1">
//               <input
//                 value={searchTerm}
//                 onChange={(e) => {
//                   setSearchTerm(e.target.value);
//                 }}
//                 placeholder="Search orders, customer or phone..."
//                 className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-200"
//               />
//             </div>

//             <select
//               value={statusFilter}
//               onChange={(e) => setStatusFilter(e.target.value)}
//               className="px-4 py-2 border rounded-lg focus:outline-none"
//             >
//               <option value="all">All Status</option>
//               <option value="Success">Success</option>
//               <option value="Pending">Pending</option>
//               <option value="Failed">Failed</option>
//               <option value="Shipped">Shipped</option>
//               <option value="Delivered">Delivered</option>
//               <option value="Cancelled">Cancelled</option>
//               <option value="Return Initiated">Return Initiated</option>
//               <option value="Returned">Returned</option>
//               <option value="intransit">In Transit</option>
//             </select>

//             <input
//               type="date"
//               value={dateFilter}
//               onChange={(e) => setDateFilter(e.target.value)}
//               className="px-4 py-2 border rounded-lg"
//             />

//             <div className="flex items-center space-x-2">
//               <button
//                 onClick={() => {
//                   setSearchTerm("");
//                   setStatusFilter("all");
//                   setDateFilter("");
//                 }}
//                 className="px-4 py-2 border rounded-lg"
//               >
//                 Reset
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Table area using GenericTable */}
//         <div className="bg-white rounded-lg shadow border overflow-hidden w-full">
//           <div className="p-4">
//             <GenericTable
//               columns={columns}
//               data={filteredRows}
//               customRenderers={customRenderers}
//               headerClassName="bg-red-700 text-white"
//               rowKey="orderId"
//               stripedRows={true}
//               hoverEffect={true}
//               rowsPerPageOptions={rowsPerPageOptions}
//               defaultRowsPerPage={defaultRowsPerPage}
//               // ---- This prop renders the expanded content directly under the row.
//               // If your GenericTable does not support this prop yet, I can patch it quickly.
//               renderExpandedRow={renderExpandedRow}
//             />
//           </div>

//           {/* If your GenericTable doesn't support inline expansion, the following fallback renders expanded card below the table.
//               It's a backup — remove if your GenericTable handles renderExpandedRow correctly. */}
//           {/*
//             <div className="divide-y">
//               {expandedRow && (
//                 <div className="p-4 bg-gray-50 border-t">
//                   <OrderCard
//                     orderId={expandedRow}
//                     items={(filteredRows.find(r => r.orderId === expandedRow) || {}).items || []}
//                     handleRefetch={handleRefetch}
//                   />
//                 </div>
//               )}
//             </div>
//           */}
//         </div>

//         {/* Courier Modal (keeps same UI) */}
//         {showCourierModal && (
//           <div className="fixed inset-0 bg-black/10 backdrop-blur-sm flex items-center justify-center z-50 px-4">
//             <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
//               <div className="flex items-center justify-between px-4 py-3 border-b">
//                 <div className="flex items-center gap-2">
//                   <i className="bi bi-truck text-xl text-blue-600"></i>
//                   <h2 className="text-lg font-semibold">
//                     Edit Delivery Details
//                   </h2>
//                 </div>
//                 <button onClick={() => setShowCourierModal(false)}>
//                   <i className="bi bi-x-lg text-lg"></i>
//                 </button>
//               </div>

//               <div className="p-5 space-y-4">
//                 <p className="text-sm text-gray-500">
//                   Order Id : #{selectedOrderId}
//                 </p>

//                 {courierError && (
//                   <p className="text-red-600 text-sm">{courierError}</p>
//                 )}
//                 <div>
//                   <label className="text-sm font-medium text-gray-700">
//                     Delivery Provider *
//                   </label>

//                   <select
//                     value={courierData.provider}
//                     onChange={(e) => {
//                       const selected = providers.find(
//                         (p) => p.delivery_partner_name === e.target.value
//                       );

//                       setCourierData({
//                         ...courierData,
//                         provider: selected?.delivery_partner_name || "",
//                         link: selected?.tracking_link || "",
//                         tracking: "", // reset tracking when provider changes
//                       });
//                     }}
//                     className="w-full px-3 py-2 border rounded-lg"
//                   >
//                     <option value="">Select Provider</option>

//                     {providers.map((p) => (
//                       <option key={p.id} value={p.delivery_partner_name}>
//                         {p.delivery_partner_name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* <div>
//                   <label className="text-sm font-medium text-gray-700">
//                     Delivery Provider *
//                   </label>
//                   <input
//                     type="text"
//                     value={courierData.provider}
//                     onChange={(e) =>
//                       setCourierData({ ...courierData, provider: e.target.value })
//                     }
//                     className="w-full px-3 py-2 border rounded-lg"
//                   />
//                 </div> */}

//                 <div>
//                   <label className="text-sm font-medium text-gray-700">
//                     Tracking ID *
//                   </label>
//                   <input
//                     type="text"
//                     value={courierData.tracking}
//                     onChange={(e) =>
//                       setCourierData({
//                         ...courierData,
//                         tracking: e.target.value,
//                       })
//                     }
//                     className="w-full px-3 py-2 border rounded-lg"
//                   />
//                 </div>

//                 <div>
//                   <label className="text-sm font-medium text-gray-700">
//                     Tracking Link
//                   </label>
//                   <input
//                     type="text"
//                     value={courierData.link}
//                     onChange={(e) =>
//                       setCourierData({ ...courierData, link: e.target.value })
//                     }
//                     className="w-full px-3 py-2 border rounded-lg"
//                   />
//                 </div>

//                 <div>
//                   <label className="text-sm font-medium text-gray-700">
//                     Notes
//                   </label>
//                   <textarea
//                     value={courierData.notes}
//                     onChange={(e) =>
//                       setCourierData({ ...courierData, notes: e.target.value })
//                     }
//                     className="w-full px-3 py-2 border rounded-lg"
//                     rows="3"
//                   />
//                 </div>
//               </div>

//               <div className="px-4 py-3 border-t flex justify-end gap-3">
//                 <button
//                   className="px-4 py-2 rounded-lg"
//                   onClick={() => setShowCourierModal(false)}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   className="px-4 py-2 bg-blue-600 text-white rounded-lg"
//                   onClick={handleCourierSave}
//                 >
//                   Save
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//         {showViewModal && (
//           <div className="fixed inset-0 bg-black/10 backdrop-blur-sm flex items-center justify-center z-50 px-4">
//             <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
//               {/* Header */}
//               <div className="flex items-center justify-between px-4 py-3 border-b">
//                 <div className="flex items-center gap-2">
//                   <i className="bi bi-eye text-xl text-indigo-600"></i>
//                   <h2 className="text-lg font-semibold">
//                     Order Details — #{viewOrderId}
//                   </h2>
//                 </div>

//                 <button onClick={() => setShowViewModal(false)}>
//                   <i className="bi bi-x-lg text-lg"></i>
//                 </button>
//               </div>

//               {/* Body — OrderCard */}
//               <div className="p-5">
//                 <OrderCard
//                   orderId={viewOrderId}
//                   items={viewOrderItems}
//                   handleRefetch={handleRefetch}
//                 />
//               </div>
//             </div>
//           </div>
//         )}

//         {/* small refresh button */}
//         <div className="mt-4 flex justify-end">
//           <button
//             onClick={handleRefetch}
//             className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
//           >
//             Refresh
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ManageOrders;
// ManageOrders.jsx (full, updated for Option A)
// Place in src/Orders/ManageOrders.jsx
import React, { useEffect, useMemo, useState, useRef } from "react";
import axios from "axios";
import GenericTable from "../Components/DynamicComp/Table";
import OrderCard from "./OrderCard";
import { GetOrderData } from "./OrderFunction";
import { showAlert } from "../Components/DynamicComp/Alert";

const ManageOrders = () => {
  // --- state: orders and UI
  const [groupedOrders, setGroupedOrders] = useState({});
  const [loading, setLoading] = useState(false);
  const [refetchToggle, setRefetchToggle] = useState(false);

  // filters
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [dateFilter, setDateFilter] = useState("");

  // view modal and its items
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewOrderItems, setViewOrderItems] = useState([]); // items for opened order
  const [viewOrderId, setViewOrderId] = useState(null);

  // barcode global scanner states
  const [barcode, setBarcode] = useState("");
  const [batchResult, setBatchResult] = useState("");
  const barcodeInputRef = useRef(null);

  // courier modal
  const [showCourierModal, setShowCourierModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [courierData, setCourierData] = useState({ provider: "", tracking: "", link: "", notes: "" });
  const [providers, setProviders] = useState([]);
  const [courierError, setCourierError] = useState("");

  // inline expand
  const [expandedRow, setExpandedRow] = useState(null);

  // fetch orders
  useEffect(() => {
    fetchOrders();
    setExpandedRow(null);
  }, [refetchToggle]);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const res = await GetOrderData();
      const arr = Array.isArray(res?.data) ? res.data : [];
      const grouped = arr.reduce((acc, it) => {
        const id = it.order_id;
        if (!acc[id]) acc[id] = [];
        acc[id].push(it);
        return acc;
      }, {});
      Object.keys(grouped).forEach((k) => {
        grouped[k].sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
      });
      setGroupedOrders(grouped);
    } catch (err) {
      console.error("Fetch orders error:", err);
      showAlert?.("Failed to fetch orders", "error");
    } finally {
      setLoading(false);
    }
  };
  const handleRefetch = () => setRefetchToggle((p) => !p);

  // load providers
  useEffect(() => {
    const load = async () => {
      try {
        const r = await axios.get("http://localhost:5000/api/orders/delivery-providers");
        setProviders(r.data || []);
      } catch (e) {
        console.error("Providers load failed", e);
      }
    };
    load();
  }, []);

  // ------------------------------
  // Helper: update packaged qty for order modal UI
  // ------------------------------
  const updatePackageQty = (productId, delta) => {
    setViewOrderItems((prev) => prev.map((it) =>
      Number(it.product_id) === Number(productId)
        ? { ...it, pkg_qty: (Number(it.pkg_qty || 0) + Number(delta)) }
        : it
    ));
    // Also update groupedOrders so the change persists if you re-open
    setGroupedOrders(prev => {
      const copy = { ...prev };
      if (!viewOrderId || !copy[viewOrderId]) return copy;
      copy[viewOrderId] = copy[viewOrderId].map(it =>
        Number(it.product_id) === Number(productId)
          ? { ...it, pkg_qty: (Number(it.pkg_qty || 0) + Number(delta)) }
          : it
      );
      return copy;
    });
  };

  // ------------------------------
  // Handle open courier modal & save
  // Must be defined BEFORE customRenderers (used in renderers)
  // ------------------------------
  const handleOpenCourierModal = async (orderId) => {
    setSelectedOrderId(orderId);
    setCourierError("");
    try {
      const res = await axios.get(`http://localhost:5000/api/order-delivery/${orderId}`);
      const d = res.data || {};
      setCourierData({
        provider: d.delivery_provider || "",
        tracking: d.tracking_id || "",
        link: d.tracking_link || "",
        notes: d.notes || "",
      });
    } catch (err) {
      console.error("Failed to load delivery details", err);
      setCourierData({ provider: "", tracking: "", link: "", notes: "" });
    }
    setShowCourierModal(true);
  };

  const handleCourierSave = async () => {
    setCourierError("");
    if (!courierData.provider.trim() || !courierData.tracking.trim()) {
      setCourierError("Delivery Provider & Tracking Number are required!");
      return;
    }
    try {
      const res = await axios.post("http://localhost:5000/api/orders/order-delivery/save", {
        order_id: selectedOrderId,
        delivery_provider: courierData.provider,
        tracking_id: courierData.tracking,
        tracking_link: courierData.link,
        notes: courierData.notes,
      });
      if (res?.data?.success) {
        showAlert({ type: "success", title: "Delivery details saved", duration: 2000 });
        setShowCourierModal(false);
      } else {
        showAlert("Failed to save delivery details!", "error");
      }
    } catch (err) {
      console.error(err);
      showAlert("Server error!", "error");
    }
  };

  // ------------------------------
  // Global barcode handler: full flow
  //  - read barcode (single scan or manual)
  //  - get batch by code
  //  - find matching product in currently open order
  //  - validate ordered qty and batch qty
  //  - update UI (pkg_qty) and call backend to deduct
  // ------------------------------
  const handleGlobalBarcodeCheck = async () => {
    if (!barcode.trim()) {
       showAlert({
          type: "Failure",
          title: "Scan or Enter a barcode",
          duration: 2500,
        });
      // setBatchResult("Enter barcode");
      return;
    }

    const batchCode = encodeURIComponent(barcode.trim());
    setBatchResult("Checking...");

    try {
      const res = await axios.get(`http://localhost:5000/api/batch/code/${batchCode}`);
      if (!res?.data) {
        setBatchResult("Invalid barcode response");
        return;
      }
      // support drivers that return debug rows or direct object
      const batch = res.data.batch_id ? res.data : (res.data.debug && res.data.debug[0]) || res.data;

      if (!batch || !batch.batch_id) {
        setBatchResult("❌ Batch not found");
        return;
      }

      // batch.quantity or batch.quantity_in_hand might be the field — handle both
      const batchQty = batch.quantity ?? batch.quantity_in_hand ?? batch.quantityInHand ?? 0;

      if (Number(batchQty) <= 0) {
         showAlert({
          type: "Failure",
          title: "Out of Stock",
          duration: 2500,
        });
        // setBatchResult("❌ Out of Stock");
        return;
      }

      // find product inside current viewOrderItems
      const matched = viewOrderItems.find(it => Number(it.product_id) === Number(batch.product_id));
      if (!matched) {
          showAlert({
          type: "Failure",
          title: "This product is NOT in the order",
          duration: 2500,
        });
        setBatchResult("❌ This product is NOT in the order");
        return;
      }

      const alreadyPacked = Number(matched.pkg_qty || 0);
      const orderedQty = Number(matched.quantity || 0);

      if (alreadyPacked >= orderedQty) {
         showAlert({
          type: "Failure",
          title: "⚠ You already reached required quantity",
          duration: 2500,
        });
        setBatchResult("⚠ You already reached required quantity");
        return;
      }

      // SUCCESS path: update UI and deduct 1 from batch on backend
      updatePackageQty(matched.product_id, 1);

      // call backend deduct
      try {
        await axios.post(`http://localhost:5000/api/batch/${batch.batch_id}/deduct`, { quantity: 1 });
      } catch (deductErr) {
        // rollback UI if backend fails
        updatePackageQty(matched.product_id, -1);
        console.error("Batch deduct error:", deductErr);
         showAlert({
          type: "Failed",
          title: "Failed to deduct batch stock",
          duration: 2500,
        });
        //setBatchResult("❌ Failed to deduct batch stock");
        return;
      }

      const remaining = Number(batchQty) - 1;
       showAlert({
          type: "success",
          title: " ✔ Package added successfully(1)",
          duration: 2500,
        });
      setBatchResult(`✔ Added 1 package — batch remaining: ${remaining}`);
      setBarcode("");
      // autofocus again
      setTimeout(() => barcodeInputRef.current?.focus(), 80);

      // optional: refresh parent lists (if necessary)
      // handleRefetch(); // uncomment if you want a full refresh

    } catch (err) {
      console.error("Barcode check error:", err);
       showAlert({
          type: "Failure",
          title: " ❌Server error",
          duration: 2500,
        });
      setBatchResult("❌ Server error");
    }
  };

  // ========================================================
  // Table columns, renderers, filtering etc.
  // ========================================================
  const columns = [
    { key: "orderId", label: "Order ID" },
    { key: "name", label: "Customer" },
    { key: "date", label: "Order Date" },
    { key: "amount", label: "Amount" },
    { key: "status", label: "Status" },
    { key: "actions", label: "Actions", align: "center", width: "160px" },
  ];

  const customRenderers = {
    date: (row) => {
      try { return new Date(row.date).toLocaleDateString(); } catch { return "-"; }
    },
    amount: (row) => `₹${row.amount}`,
    status: (row) => {
      const s = (row.status || "").toLowerCase();
      const map = { delivered: "bg-green-100 text-green-700", pending: "bg-yellow-100 text-yellow-700", cancelled: "bg-red-100 text-red-700" };
      const cls = map[s] || "bg-gray-100 text-gray-700";
      return <span className={`px-3 py-1 rounded-full text-xs font-semibold ${cls}`}>{row.status}</span>;
    },
    actions: (row) => (
      <div className="flex items-center justify-center gap-2">
        <button onClick={() => {
          setViewOrderId(row.orderId);
          setViewOrderItems(row.items || []);
          setShowViewModal(true);
          setBatchResult("");
          setTimeout(() => barcodeInputRef.current?.focus(), 200);
        }} className="px-3 py-1 bg-indigo-600 text-white rounded-md text-xs">View</button>

        <button onClick={() => handleOpenCourierModal(row.orderId)} className="px-3 py-1 bg-green-600 text-white rounded-md text-xs">Delivery</button>

        <button onClick={() => handleCancelOrder(row)} className="px-2 py-1 bg-red-600 text-white rounded-md text-xs" title="Cancel Order"><i className="bi bi-trash"></i></button>
      </div>
    )
  };

  // cancel order
  const handleCancelOrder = async (row) => {
    if (!window.confirm(`Cancel order #${row.orderId}?`)) return;
    try {
      const res = await axios.post("http://localhost:5000/api/orders/update-status", { order_id: row.orderId, status: "cancelled" });
      if (res?.data?.success) {
        showAlert?.("Order cancelled successfully!", "success");
        setGroupedOrders(prev => {
          const copy = { ...prev };
          if (copy[row.orderId]) {
            copy[row.orderId] = copy[row.orderId].map(it => ({ ...it, status: "cancelled" }));
          }
          return copy;
        });
      }
    } catch (e) {
      showAlert?.("Failed to cancel order", "error");
    }
  };

  // expand row
  const handleToggleExpand = (orderId) => setExpandedRow(prev => (prev === orderId ? null : orderId));
  const renderExpandedRow = (row) => {
    if (expandedRow !== row.orderId) return null;
    return (
      <div className="w-full bg-gray-50 p-4 border-t">
        <OrderCard orderId={row.orderId} items={row.items} handleRefetch={handleRefetch} />
      </div>
    );
  };

  // flatten rows
  const allRows = useMemo(() => {
    const entries = Object.entries(groupedOrders || {});
    return entries.map(([orderId, items]) => {
      const first = items[0] || {};
      const totalAmount = items.reduce((t, it) => t + Number(it.amount || 0) * Number(it.quantity || 1), 0);
      return { orderId, name: first.name || "-", date: first.created_at || first.updated_at || "", amount: Number(totalAmount || 0).toFixed(2), status: first.status || "-", items };
    });
  }, [groupedOrders]);

  const filteredRows = useMemo(() => {
    const lower = searchTerm.trim().toLowerCase();
    return allRows.filter(r => {
      if (lower) {
        const matches = (r.orderId + "").toLowerCase().includes(lower) || (r.name + "").toLowerCase().includes(lower) || r.items.some(it => ((it.phone || it.mobile || "") + "").toLowerCase().includes(lower));
        if (!matches) return false;
      }
      if (statusFilter !== "all" && (r.status || "").toLowerCase() !== statusFilter.toLowerCase()) return false;
      if (dateFilter) {
        const matches = r.items.some(it => new Date(it.created_at).toISOString().slice(0, 10) === dateFilter);
        if (!matches) return false;
      }
      return true;
    }).sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));
  }, [allRows, searchTerm, statusFilter, dateFilter]);

  const stats = useMemo(() => {
    const flat = allRows.flatMap(r => r.items);
    const count = s => flat.filter(it => (it.status || "").toLowerCase() === s.toLowerCase()).length;
    return { newOrders: count("pending"), inTransit: count("shipped") + count("in transit") + count("intransit"), delivered: count("delivered"), total: flat.length };
  }, [allRows]);

  // Auto-focus the barcode input when view modal opens
  useEffect(() => {
    if (showViewModal) {
      setTimeout(() => barcodeInputRef.current?.focus(), 120);
    } else {
      setBatchResult("");
      setBarcode("");
    }
  }, [showViewModal]);

  // final render
  return (
    <div className="p-6 bg-gray-50 min-h-screen w-full">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6"><h1 className="text-3xl font-bold text-gray-800">Manageorders</h1></div>

        {/* stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
          <div className="bg-white p-4 rounded-xl shadow-sm border"><p className="text-sm text-gray-500">New Orders</p><p className="text-2xl font-semibold text-indigo-600">{stats.newOrders}</p></div>
          <div className="bg-white p-4 rounded-xl shadow-sm border"><p className="text-sm text-gray-500">In Transit</p><p className="text-2xl font-semibold text-orange-500">{stats.inTransit}</p></div>
          <div className="bg-white p-4 rounded-xl shadow-sm border"><p className="text-sm text-gray-500">Delivered</p><p className="text-2xl font-semibold text-emerald-600">{stats.delivered}</p></div>
        </div>

        {/* controls */}
        <div className="bg-white p-4 rounded-xl shadow-sm border mb-6">
          <div className="flex flex-col md:flex-row md:items-center gap-3">
            <div className="flex-1"><input value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} placeholder="Search orders, customer or phone..." className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-200" /></div>

            <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="px-4 py-2 border rounded-lg">
              <option value="all">All Status</option>
              <option value="Success">Success</option>
              <option value="Pending">Pending</option>
              <option value="Failed">Failed</option>
              <option value="Shipped">Shipped</option>
              <option value="Delivered">Delivered</option>
              <option value="Cancelled">Cancelled</option>
              <option value="Return Initiated">Return Initiated</option>
              <option value="Returned">Returned</option>
              <option value="intransit">In Transit</option>
            </select>

            <input type="date" value={dateFilter} onChange={(e) => setDateFilter(e.target.value)} className="px-4 py-2 border rounded-lg" />
            <div className="flex items-center space-x-2"><button onClick={() => { setSearchTerm(""); setStatusFilter("all"); setDateFilter(""); }} className="px-4 py-2 border rounded-lg">Reset</button></div>
          </div>
        </div>

        {/* table */}
        <div className="bg-white rounded-lg shadow border overflow-hidden w-full">
          <div className="p-4">
            <GenericTable columns={columns} data={filteredRows} customRenderers={customRenderers} headerClassName="bg-red-700 text-white" rowKey="orderId" stripedRows hoverEffect rowsPerPageOptions={[5,10,20]} defaultRowsPerPage={5} renderExpandedRow={renderExpandedRow} />
          </div>
        </div>

        {/* courier modal */}
        {showCourierModal && (
          <div className="fixed inset-0 bg-black/10 backdrop-blur-sm flex items-center justify-center z-50 px-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
              <div className="flex items-center justify-between px-4 py-3 border-b"><div className="flex items-center gap-2"><i className="bi bi-truck text-xl text-blue-600"></i><h2 className="text-lg font-semibold">Edit Delivery Details</h2></div><button onClick={() => setShowCourierModal(false)}><i className="bi bi-x-lg text-lg"></i></button></div>
              <div className="p-5 space-y-4">
                <p className="text-sm text-gray-500">Order Id : #{selectedOrderId}</p>
                {courierError && (<p className="text-red-600 text-sm">{courierError}</p>)}
                <div>
                  <label className="text-sm font-medium text-gray-700">Delivery Provider *</label>
                  <select value={courierData.provider} onChange={(e) => {
                    const sel = providers.find(p => p.delivery_partner_name === e.target.value);
                    setCourierData({ ...courierData, provider: sel?.delivery_partner_name || "", link: sel?.tracking_link || "", tracking: "" });
                  }} className="w-full px-3 py-2 border rounded-lg">
                    <option value="">Select Provider</option>
                    {providers.map(p => <option key={p.id} value={p.delivery_partner_name}>{p.delivery_partner_name}</option>)}
                  </select>
                </div>
                <div><label className="text-sm font-medium text-gray-700">Tracking ID *</label><input type="text" value={courierData.tracking} onChange={(e) => setCourierData({ ...courierData, tracking: e.target.value })} className="w-full px-3 py-2 border rounded-lg" /></div>
                <div><label className="text-sm font-medium text-gray-700">Tracking Link</label><input type="text" value={courierData.link} onChange={(e) => setCourierData({ ...courierData, link: e.target.value })} className="w-full px-3 py-2 border rounded-lg" /></div>
                <div><label className="text-sm font-medium text-gray-700">Notes</label><textarea value={courierData.notes} onChange={(e) => setCourierData({ ...courierData, notes: e.target.value })} className="w-full px-3 py-2 border rounded-lg" rows={3} /></div>
              </div>
              <div className="px-4 py-3 border-t flex justify-end gap-3">
                <button className="px-4 py-2 rounded-lg" onClick={() => setShowCourierModal(false)}>Cancel</button>
                <button className="px-4 py-2 bg-blue-600 text-white rounded-lg" onClick={handleCourierSave}>Save</button>
              </div>
            </div>
          </div>
        )}

        {/* VIEW modal with global barcode input */}
        {showViewModal && (
          <div className="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-50 px-4">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between px-4 py-3 border-b">
                <div className="flex items-center gap-2"><i className="bi bi-eye text-xl text-indigo-600"></i><h2 className="text-lg font-semibold">Order Details — #{viewOrderId}</h2></div>
                <button onClick={() => setShowViewModal(false)}><i className="bi bi-x-lg text-lg"></i></button>
              </div>

              {/* global barcode input */}
              {/* <div className="mt-4 p-4 border-b bg-gray-50">
                <h3 className="text-lg font-semibold mb-2">Scan Product Barcode</h3>
                <div className="flex gap-3">
                  <input ref={barcodeInputRef} type="text" value={barcode} onChange={(e) => setBarcode(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") handleGlobalBarcodeCheck(); }} placeholder="Scan or type barcode and press Enter" className="border p-2 rounded w-full" />
                  <button onClick={handleGlobalBarcodeCheck} className="px-4 bg-indigo-600 text-white rounded">Check</button>
                </div>
                {batchResult && <p className="mt-2 text-sm font-semibold text-gray-700">{batchResult}</p>}
              </div> */}

              <div className="p-5">
                <OrderCard orderId={viewOrderId} items={viewOrderItems} handleRefetch={handleRefetch} />
              </div>
            </div>
          </div>
        )}

        {/* refresh */}
        <div className="mt-4 flex justify-end"><button onClick={handleRefetch} className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">Refresh</button></div>
      </div>
    </div>
  );
};

export default ManageOrders;
